export const groups = [
    {
      category: { tr: "Faaliyet Raporları", en: "Activity Reports" },
      period:   { tr: "2025", en: "2025" },
      items: [
        {
          classfield: "activity",
          title: { tr: "1Ç2025 Ara Dönem Faaliyet Raporu", en: "Q1 2025 Interim Activity Report" },
          href:  { tr: "/static/docs/reports/2025-q1-activity-tr.pdf", en: "/static/docs/reports/2025-q1-activity-en.pdf" }
        },
        {
          classfield: "financial",
          title: { tr: "1Ç2025 Ara Dönem Finansal Tablolar", en: "Q1 2025 Interim Financial Statements" },
          href:  { tr: "/static/docs/reports/2025-q1-financials-tr.pdf", en: "/static/docs/reports/2025-q1-financials-en.pdf" }
        },
      ]
    },
    {
        category: { tr: "Sürdürülebilirlik Raporu", en: "Sustainability Report" },
        period:   { tr: "2025", en: "2025" },
        items: [
          {
            classfield: "sustainability",
            title: { tr: "2025 Sürdürülebilirlik Raporu", en: "2025 Sustainability Report" },
            href:  { tr: "/static/docs/reports/2025-sustainability-tr.pdf", en: "/static/docs/reports/2025-sustainability-en.pdf" }
          }
        ]
      },
    {
      category: { tr: "Sürdürülebilirlik Raporu", en: "Sustainability Report" },
      period:   { tr: "2024", en: "2024" },
      items: [
        {
          classfield: "sustainability",
          title: { tr: "2024 Sürdürülebilirlik Raporu", en: "2024 Sustainability Report" },
          href:  { tr: "/static/docs/reports/2025-sustainability-tr.pdf", en: "/static/docs/reports/2025-sustainability-en.pdf" }
        }
      ]
    },
    {
      category: { tr: "Kurumsal Yönetim Uyum Raporu ve Kurumsal Yönetim Bilgi Formu", en: "Corporate Governance Compliance Report & Information Form" },
      period:   { tr: "2024", en: "2024" },
      items: [
        {
          classfield: "cg-compliance",
          title: { tr: "Kurumsal Yönetim Uyum Raporu", en: "Corporate Governance Compliance Report" },
          href:  { tr: "/static/docs/reports/2025-cg-compliance-tr.pdf", en: "/static/docs/reports/2025-cg-compliance-en.pdf" }
        },
        {
          classfield: "cg-info",
          title: { tr: "Kurumsal Yönetim Bilgi Formu", en: "Corporate Governance Information Form" },
          href:  { tr: "/static/docs/reports/2025-cg-info-tr.pdf", en: "/static/docs/reports/2025-cg-info-en.pdf" }
        },
      ]
    },
    {
      category: { tr: "Sürdürülebilirlik Uyum Raporu", en: "Sustainability Compliance Report" },
      period:   { tr: "2025", en: "2025" },
      items: [
        {
          classfield: "sus-compliance",
          title: { tr: "2025 Sürdürülebilirlik Uyum Raporu", en: "2025 Sustainability Compliance Report" },
          href:  { tr: "/static/docs/reports/2025-sus-compliance-tr.pdf", en: "/static/docs/reports/2025-sus-compliance-en.pdf" }
        }
      ]
    },
    {
      category: { tr: "Kurumsal Yönetim Raporu", en: "Corporate Governance Report" },
      period:   { tr: "2025", en: "2025" },
      items: [
        {
          classfield: "cg-report",
          title: { tr: "2025 Kurumsal Yönetim Raporu", en: "2025 Corporate Governance Report" },
          href:  { tr: "/static/docs/reports/2025-cg-report-tr.pdf", en: "/static/docs/reports/2025-cg-report-en.pdf" }
        }
      ]
    },
    {
      category: { tr: "Kredi Derecelendirme Raporları", en: "Credit Rating Reports" },
      period:   { tr: "2025", en: "2025" },
      items: [
        {
          classfield: "credit-rating",
          title: { tr: "2025 Kredi Derecelendirme Raporu", en: "2025 Credit Rating Report" },
          href:  { tr: "/static/docs/reports/2025-credit-rating-tr.pdf", en: "/static/docs/reports/2025-credit-rating-en.pdf" }
        }
      ]
    },
    {
      category: { tr: "Kurumsal Yönetim Derecelendirme Raporları", en: "Corporate Governance Rating Reports" },
      period:   { tr: "2025", en: "2025" },
      items: [
        {
          classfield: "cg-rating",
          title: { tr: "2025 Kurumsal Yönetim Derecelendirme Raporu", en: "2025 Corporate Governance Rating Report" },
          href:  { tr: "/static/docs/reports/2025-cg-rating-tr.pdf", en: "/static/docs/reports/2025-cg-rating-en.pdf" }
        }
      ]
    },
  ];